<div class='control'>
    <div class='form-group'>
        <label [for]="'i-' + id" [class.default]='!labelName' [formGroup]='form'>
			<span *ngIf='labelName && showLabel' class='custom-label control-label'>{{
                labelName
                }}</span>
            <input
                #element
                [id]="'i-' + id"
                type="text"
                [attr.name]='name'
                [formControlName]='name'
                [placeholder]='placeholder || ""'
                [setValue]='inputModel'
                (keyup)='onChange($event, element.value)'
                class='form-control custom-input'
                [ngClass]="{'mt-0': !showLabel}"
                [attr.disabled]="disabled == true ? true : null"
            />
            <span *ngIf="showLoading" class="spinner-border text-primary" role="status"></span>
            <div [ngClass]="itemsList.length > 0 ? '' : 'drop-area-hide'" class="drop-area">
                <div *ngFor="let item of itemsList; let i = index"  [id]="'i-' + item.value" class="drop-item" (click)="item.value === '00' ? semDado() : selectItem(item)">{{item.label}}</div>
            </div>
        </label>
        <span *ngIf='callout' class='callout'>{{ callout }}</span>
        <ng-container *ngIf="form?.get(name?.toString() ?? '') as control">
            <span
                *ngIf="control.invalid && (control.touched || control.dirty)"
                class="control-error control-error-autocomplete"
                [setFormControlError]="{ objError: control.errors, control: labelName }"
            >
            </span>
        </ng-container>
    </div>
</div>

